<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    width="920px"
    top="7vh"
    append-to-body
    :close-on-click-modal="false"
    :lock-scroll="true"
    custom-class="workoutBindingPickerDialog"
    @opened="handleOpened"
    @closed="handleClosed"
  >
    <resource-picker-panel
      v-if="innerVisible"
      ref="picker"
      class="workoutBindingPickerDialog__panel"
      :value="pendingSelection"
      :filters="pickerFilters"
      :lock-asset-type="assetType"
      workout-exta-mode
      @input="pendingSelection = $event"
    />
    <span slot="footer" class="workoutBindingPickerDialog__footer">
      <el-button size="small" @click="innerVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm">选好了</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ResourcePickerPanel from '../../batchTag/ResourcePickerPanel.vue'

export default {
  name: 'WorkoutBindingPickerDialog',
  components: { ResourcePickerPanel },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '挑选资源' },
    assetType: { type: String, required: true },
    /** 已绑定资源的 key，弹窗内预选时排除重复 */
    excludeKeys: { type: Array, default: () => [] },
  },
  data() {
    return {
      pendingSelection: [],
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(next) {
        this.$emit('update:visible', next)
      },
    },
    pickerFilters() {
      return { assetType: this.assetType }
    },
    excludeKeySet() {
      return new Set((this.excludeKeys || []).filter(Boolean))
    },
  },
  watch: {
    visible(next) {
      if (next) {
        this.pendingSelection = []
      }
    },
  },
  methods: {
    handleOpened() {
      // 弹层动画结束后才有稳定 flex 高度，再让表格按 wrap 重测，否则首屏/查询后易滚不动
      this.$nextTick(() => {
        const picker = this.$refs.picker
        if (picker && typeof picker.remeasureTableHeight === 'function') {
          picker.remeasureTableHeight()
        }
      })
    },
    handleConfirm() {
      const picked = (this.pendingSelection || []).filter(
        (row) => row && row.key && !this.excludeKeySet.has(row.key)
      )
      if (!picked.length) {
        this.$message.warning('请至少勾选一个资源')
        return
      }
      this.$emit('confirm', picked)
      this.innerVisible = false
    },
    handleClosed() {
      this.pendingSelection = []
    },
  },
}
</script>

<style src="./workoutBindingPickerDialog.css"></style>
<style src="../../linkModuleSurfaces.css"></style>
